<script setup lang="ts">
import { TickerDirection, TickerType } from '@pkg/sanity-utils/constants/direction';
import { computed, type Component } from 'vue';
import { THEME } from '@pkg/config/misc/theme';

const props = defineProps<{
  block?: {
    _type: string,
    _key: string
    anchorId?: string;
    items?: null | Array<{
      name?: string
    }>;
    direction?: TickerDirection;
    theme?: THEME;
    tickerType?: TickerType;
    logos?: Array<{
      _type: string,
      _key: string
      _ref?: string
    }>;
  },
  config: {
    innerComponent?: Component
  },
}>();

const data = computed(() => ({
  items: props.block?.items?.map(item => item.name),
  reversed: props.block?.direction === TickerDirection.REVERSED,
  theme: props.block?.theme ?? THEME.DARK_ALT,
  tickerType: props.block?.tickerType,
  logos: props.block?.logos,
}));

</script>

<template>
  <component v-if="props.block?.items || (props.block?.tickerType === TickerType.LOGO_TICKER && props.block?.logos)" :is="props.config?.innerComponent" :id="props.block?.anchorId" v-bind="data"/>
</template>
